import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cart-widget__items" }

import {
  computed,
} from 'vue';
import { useStore } from 'vuex';
import { Product } from '@/classes';
import CartItem from '@/components/cart/CartItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CartItems',
  emits: ['remove'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const store = useStore();

const cartCommodity = computed(() => store.getters['cart/commodity']);

const commodityProducts = computed(() => {
  const cp = [] as Array<{ key: string, product: Product }>;

  Object.keys(cartCommodity.value)
    .forEach((key) => {
      const {
        product,
      } = cartCommodity.value[key] as { product: Product };

      cp.push({
        key,
        product,
      });
    });

  return cp;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commodityProducts.value, (item) => {
      return (_openBlock(), _createBlock(CartItem, {
        key: item.key,
        product: item.product,
        "item-key": item.key,
        onRemove: ($event: any) => (emit('remove', item.key, item.product))
      }, null, 8, ["product", "item-key", "onRemove"]))
    }), 128))
  ]))
}
}

})